import { lang } from '../utils'
import PersonalDataStep from '../components/PersonalDataStep'
import SummaryStep from '../components/warehouse/SummaryStep'
import SubmitStep from '../components/warehouse/SubmitStep'

export const heading = 'Bewerbung im Bereich Lagerlogistik'

export const steps = [
  {
    question: lang.qualifications,
    help: 'Welche Qualifizierungen haben Sie?',
    inputs: {
      qualifications: {
        type: 'options',
        default: [],
        multiple: true,
        layout: 'column',
        options: [
          { value: 'Ich habe einen Staplerschein' },
          { value: 'Ich habe einen Führerschein Klasse B' },
          { value: 'Ich habe Erfahrungen im Warehouse/Lager' },
          { value: 'Ich habe Erfahrungen in der Produktion' },
          { value: 'Ich habe EDV-Kenntnisse' },
        ],
        rule: v8n => v8n().array().not.empty(),
        errorMessage: lang.select_all_that_apply,
      },
    },
  },
  {
    question: lang.linquistic_proficiency,
    help: 'Welche Sprachkenntnisse bringen Sie mit?',
    inputs: {
      languages: {
        type: 'options',
        multiple: true,
        default: [],
        options: [
          { value: 'Deutsch' },
          { value: 'Englisch' },
        ],
      },
      language_others: {
        type: 'text',
        label: 'Andere',
        rule: (v8n, { languages }) => {
          if (languages.length === 0) {
            return v8n().string().not.empty().maxLength(100)
          }
          return v8n()
        },
        errorMessage: 'Bitte alle zutreffenden auswählen.',
      },
    },
  },
  {
    question: lang.possible_start_of_work,
    help: 'Zu welchem Termin könnten Sie bei uns einsteigen?',
    inputs: {
      start_of_work: {
        type: 'date',
        default: (new Date()).toLocaleDateString('en-CA'),
        label: 'Einstiegstermin',
      },
    },
  },
  {
    question: lang.salary_expectations,
    required: false,
    inputs: {
      expected_salary: {
        type: 'text',
      },
    },
  },
  {
    component: PersonalDataStep,
    question: lang.personal_data,
    description: 'Geben Sie hier bitte Ihre persönlichen Daten an, damit wir uns mit Ihnen in Kontakt setzen können.\n' +
      '[Checkbox to request consent] DSGVO-Einwilligung* [ ] Ich willige ein, dass CDS die Daten zur\n' +
      'Kontaktaufnahme nutzen darf. Selbstverständlich werden die Daten gelöscht, sobald sie nicht mehr\n' +
      'gebraucht werden.',
    inputs: {
      street: {
        type: 'text',
        label: lang.street,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Straße an.',
      },
      house_number: {
        type: 'text',
        label: lang.house_number,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Hausnummer an.',
      },
      city: {
        type: 'text',
        label: lang.city,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Stadt an.',
      },
      postal: {
        type: 'text',
        label: lang.postal_code,
        rule: v8n => v8n().string().not.empty().numeric().length(5),
        errorMessage: 'Bitte geben Sie eine gültige Postleitzahl an.',
      },
      salutation: {
        type: 'select',
        default: 'Herr',
        label: 'Anrede',
        options: [
          { value: 'Herr' },
          { value: 'Frau' },
          { value: 'Divers' },
        ],
      },
      first_name: {
        type: 'text',
        label: lang.first_name,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie einen gültigen Vornamen an.',
      },
      last_name: {
        type: 'text',
        label: lang.last_name,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie einen gültigen Nachnamen an.',
      },
      telephone_number: {
        type: 'tel',
        label: lang.telephone,
        rule: v8n => v8n().string().not.empty().maxLength(100),
        errorMessage: 'Bitte geben Sie eine gültige Telefonnummer an.',
      },
      email: {
        type: 'email',
        label: lang.email,
        rule: v8n => v8n().string().not.empty().maxLength(100).pattern(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
        ),
        errorMessage: `Bitte geben Sie eine gültige ${lang.email} an.`,
      },
      email_confirmation: {
        type: 'email',
        label: 'E-Mail-Adresse wiederholen',
        rule: (v8n, form) => v8n().string().equal(form.email),
        errorMessage: `Bitte stellen Sie sicher, dass die E-Mail-Adresse übereinstimmt.`,
      },
    },
  },
  {
    question: lang.additional_information,
    help: 'Wollen Sie uns darüber hinaus noch etwas mitteilen? Außerdem können Sie optional Dokumente\n' +
      'wie z.B. einen Lebenslauf hochladen.',
    required: false,
    inputs: {
      additional_information: {
        type: 'textarea',
        rule: v8n => v8n().
          optional(v8n().string().not.empty().maxLength(200), true),
        errorMessage: 'Bitte geben Sie eine gültige Eingabe ein.',
      },
      file_upload: {
        type: 'file',
        label: 'File upload',
      },
    },
  },
  {
    component: SummaryStep,
    question: 'Ihre Angaben (Korrekturen Sind Möglich)',
    inputs: {},
  },
  {
    component: SubmitStep,
    question: 'Absenden der Bewerbung',
    inputs: {},
  },
]